import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly label: string;
  /** The alternative action: ink outline on paper instead of filled. */
  readonly outlined?: boolean;
  readonly busy?: boolean;
  /** A mark shown before the label, e.g. a sign-in provider's logo. */
  readonly icon?: ReactNode;
}

/** Full-bleed action. Filled is the primary; outlined is the alternative. */
export function Button({ label, outlined = false, busy = false, icon, disabled, type = "button", ...rest }: ButtonProps) {
  return (
    <button
      type={type}
      className={outlined ? "btn-outline" : "btn-primary"}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      {...rest}
    >
      {busy ? (
        "…"
      ) : icon ? (
        <span className="inline-flex items-center justify-center gap-3">
          <span aria-hidden className="inline-flex">{icon}</span>
          <span>{label}</span>
        </span>
      ) : (
        label
      )}
    </button>
  );
}

interface LinkButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly label: string;
}

/** The quiet, underlined alternative under a primary action. */
export function LinkButton({ label, type = "button", ...rest }: LinkButtonProps) {
  return (
    <button type={type} className="link min-h-11 px-2 text-[15px] leading-none" {...rest}>
      {label}
    </button>
  );
}
